import { getMemberSubscriptions } from './get-member-subscriptions';
export const memberHasSubscriptions = () => !!getMemberSubscriptions();
